<template>
  <transition
    appear
    v-bind:css="false"
    v-on:enter="startTransitionAnim"
  >
    <div ref="filmHolder" class="film-anim-holder">
      <div ref="filmOne" class="film-anim-one film-anim-global"></div>
      <div ref="filmTwo" class="film-anim-two film-anim-global"></div>
      <div ref="filmThree" class="film-anim-three film-anim-global"></div>
      <div ref="filmFour" class="film-anim-four film-anim-global"></div>
      <div ref="filmFive" class="film-anim-five film-anim-global"></div>
      <div ref="filmSix" class="film-anim-six film-anim-global"></div>
      <div ref="filmBG" class="film-anim-bg film-anim-global"></div>
    </div>
  </transition>
</template>

<script>
import { inject } from "vue";
import gsap from 'gsap';

export default {
  name: "FilmAnimation",
  components: {

  },
  setup() {
    const store = inject("store");
    return {
      state: store.state,
			actions: store.actions
    }
  },
  data() {
    return{
      showTransition: false
    }
  },
  created() {
    //this.beforeEnterTransition();
  },
  mounted() {
  //  this.startTransitionAnim();
  },
  methods: {
    startTransitionAnim() {
      // console.log('start Transition');
      gsap.set(this.$refs.filmBG, { opacity: 0, x: 0, y: 0});
      gsap.set(this.$refs.filmOne, { opacity: 0, x: 0, y: 0});
      gsap.set(this.$refs.filmTwo, { opacity: 0, x: 0, y: 0});
      gsap.set(this.$refs.filmThree, { opacity: 0, x: 0, y: 0});
      gsap.set(this.$refs.filmFour, { opacity: 0, x: 0, y: 0});
      gsap.set(this.$refs.filmFive, { opacity: 0, x: 0, y: 0});
      gsap.set(this.$refs.filmSix, { opacity: 0, x: 0, y: 0});

      gsap.to(this.$refs.filmBG, { opacity: 1, duration:1, scale: 1, delay:0.5, ease: "power2.out"});
      gsap.to(this.$refs.filmOne, { opacity: 1, duration:0, scale: 1, delay:0.6});
      gsap.to(this.$refs.filmTwo, { opacity: 1, duration:0, scale: 1, delay:0.7});
      gsap.to(this.$refs.filmThree, { opacity: 1, duration:0, scale: 1, delay:0.8});
      gsap.to(this.$refs.filmFour, { opacity: 1, duration:0, scale: 1, delay:0.9});
      gsap.to(this.$refs.filmFive, { opacity: 1, duration:0, scale: 1, delay:1});
      gsap.to(this.$refs.filmSix, { opacity: 1, duration:0, scale: 1, delay:1.1});
      gsap.to(this.$refs.filmHolder, { opacity: 0, duration:0.5, scale: 1, delay:1.5, ease: "power2.out",onComplete:this.leaveTransitionAnim});
    },
    beforeEnterTransition(){
      // console.log('Enter Transition');
      gsap.set(this.$refs.filmHolder, { opacity: 0, scale: 0});
    },
    leaveTransitionAnim(){
      // console.log('Leave Transition');
      /* gsap.set(this.$refs.filmBG, { opacity: 0, x: 0, y: 0});
      gsap.set(this.$refs.filmOne, { opacity: 0, x: 0, y: 0});
      gsap.set(this.$refs.filmTwo, { opacity: 0, x: 0, y: 0});
      gsap.set(this.$refs.filmThree, { opacity: 0, x: 0, y: 0});
      gsap.set(this.$refs.filmFour, { opacity: 0, x: 0, y: 0});
      gsap.set(this.$refs.filmFive, { opacity: 0, x: 0, y: 0});
      gsap.set(this.$refs.filmSix, { opacity: 0, x: 0, y: 0}); */
    }

  }
};
</script>

<style lang="scss">

.film-anim-bg{
  background: url("../../assets/imgs/transition-film-bg.jpg") center;
  z-index: 1;
}

.film-anim-one{
  background: url("../../assets/imgs/transition-film-one.png") center;
  z-index: 10;
}


.film-anim-two{
  background: url("../../assets/imgs/transition-film-two.png") center;
  z-index: 9;
}


.film-anim-three{
  background: url("../../assets/imgs/transition-film-three.png") center;
  z-index: 8;
}


.film-anim-four{
  background: url("../../assets/imgs/transition-film-four.png") center;
  z-index: 7;
}


.film-anim-five{
  background: url("../../assets/imgs/transition-film-five.png") center;
  z-index: 6;
}


.film-anim-six{
  background: url("../../assets/imgs/transition-film-six.png") center;
  z-index: 5;
}

.film-anim-global {
  width: inherit;
  height:100%;
  background-size: cover !important;
  position: absolute;
}

.film-anim-holder{
  width:100vw;
  height: 40%;
  display: flex;
  position:absolute;
  align-content: center;
  overflow:hidden;
  z-index:100;
  // background-color:black;
    @media screen and (min-width: 729px) {
  //  height:55%;
  }
  @media screen and (max-width: 900px),screen and (max-height: 900px)  {
       // display: flex;
    height: 35%;
    justify-content: center;   
  }
  @media (max-width: 375px) {
    // display: flex;
    height: 25%;
    justify-content: center;
  }
}
</style>
